import script from "./MainView.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainView.vue?vue&type=script&lang=ts&setup=true"

import "./MainView.vue?vue&type=style&index=0&id=995a38c4&scoped=true&lang=css"

import exportComponent from "E:\\Marianne\\workspace\\notion-cooks\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-995a38c4"]])

export default __exports__